import {Button, Container} from "@mui/material";
import Heading from "./Heading";
import Table from "components/Table";
import PlusIcon from "assets/icons/PlusIcon";
import {useNavigate} from "react-router-dom";

export default function StockTaking() {
    // const {tabs} = useStockTakingData();
    const navigate = useNavigate();
    return (
        <>
            <Container maxWidth="xl">
                <Heading mainText="انبار گردانی" subText="لیست انبارگردانی های انجام شده">
                    <Button
                        variant="contained"
                        color="primary"
                        style={{gap: 10}}
                        onClick={() => navigate("/stockTaking/add")}
                    >
                        <PlusIcon color="#FFFFFF" scale={0.5}/>
                        <span>افزودن</span>
                    </Button>
                </Heading>
            </Container>
            <Table type={"stockTaking"}/>
        </>
    );
}
